import { css } from '@emotion/css';

export const filterHeightStyles = css`
  min-height: 25.8rem;
  max-height: 25.8rem;
`;
